.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.arrow {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-text-primary);
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1;
  padding: 2px 10px 4px;
  transition: background 0.15s, color 0.15s;
}

.arrow:hover {
  background: var(--color-bg-secondary);
  color: var(--color-accent);
}

.dateLabel {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-primary);
  min-width: 11ch;
  text-align: center;
}

/* Keeps layout stable when the right arrow is hidden */
.arrowPlaceholder {
  display: inline-block;
  width: calc(1.4rem + 22px); /* matches arrow button width approx */
}
